// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"75":"22db691c","318":"1d42e98e","918":"9bf055bf"}[chunkId] + ".chunk.css";
};